import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppTeam} from '@shared/models/team';
import {LinkService} from '@core/services/link.service';
import {User} from '@shared/models/user';
import {UserService} from '@core/services/user.service';

@Component({
  selector: 'app-team-cell',
  templateUrl: './team-cell.component.html',
  styleUrls: ['./team-cell.component.scss']
})
export class TeamCellComponent implements OnInit {

  @Input() currentUser: User;
  @Input() team: AppTeam;

  @Output() onFollowClick = new EventEmitter<string>();
  @Output() onUnfollowClick = new EventEmitter<string>();

  constructor(
    private userService: UserService,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
  }

  public getTeamLink(team: AppTeam): String {
    return LinkService.getTeamLink(team.readable_id);
  }

  public userIsFanOf(teamId: string) {
    if (this.currentUser == null) {
      return;
    }

    return this.currentUser.isFanOfTeamWithId(teamId);
  }

  public onFollowTeamClick(teamId: string) {
    this.onFollowClick.emit(teamId);
  }

  public onUnFollowTeamClick(teamId: string) {
    this.onUnfollowClick.emit(teamId);
  }

}
